import CryptoJS from 'crypto-js';
let SECRET_KEY = 'busbookTicket'

export const decryptText = (cipherText) => {
    try {
        const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
        return bytes.toString(CryptoJS.enc.Utf8);
    } catch (err) {
        console.error("Decryption failed", err);
        return null;
    }
};